import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

export const PIP_OVERLAY_WIDTH = 400;
export const PIP_OVERLAY_HEIGHT = 200;
export const PIP_OVERLAY_Z_INDEX = 100;

/** Dark panel chrome — prevents the map from showing through when video is loading. */
export const cameraPanelChromeSx = (theme: Theme): SystemStyleObject<Theme> => ({
  bgcolor: 'background.default',
  overflow: 'hidden',
});

/** Shared position + chrome for the 400×200 PiP in Default (camera) and Swap (map) modes. */
export const pipOverlaySx = (theme: Theme): SystemStyleObject<Theme> => ({
  ...cameraPanelChromeSx(theme),
  position: 'absolute',
  left: theme.spacing(1),
  bottom: theme.spacing(1),
  width: PIP_OVERLAY_WIDTH,
  height: PIP_OVERLAY_HEIGHT,
  zIndex: PIP_OVERLAY_Z_INDEX,
  borderRadius: 1,
  boxShadow: theme.shadows[3],
});

/** Full-area camera panel (Swap fullscreen, Split right column). */
export const cameraFullscreenPanelSx = (theme: Theme): SystemStyleObject<Theme> => ({
  ...cameraPanelChromeSx(theme),
  position: 'relative',
  width: '100%',
  height: '100%',
});

/** Split mode: separator between map and camera columns. */
export const cameraSplitPanelSx = (theme: Theme): SystemStyleObject<Theme> => ({
  ...cameraFullscreenPanelSx(theme),
  borderLeft: `1px solid ${theme.palette.divider}`,
});

/** Expand button shown when the PiP (camera or map) is collapsed. */
export const pipCollapsedExpandButtonSx = (theme: Theme): SystemStyleObject<Theme> => ({
  position: 'absolute',
  left: theme.spacing(1),
  bottom: theme.spacing(1),
  width: 50,
  height: 50,
  zIndex: PIP_OVERLAY_Z_INDEX + 1,
  bgcolor: 'background.default',
  borderRadius: 1,
  '&:hover': { bgcolor: 'background.paper' },
  '& .MuiSvgIcon-root': { fontSize: 24 },
});
